import { menuSelect } from 'instantsearch.js/es/widgets';
import { getInstance, registerWidget } from './algolia-create-instance';

function initMenuSelectWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblAlgoliaDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);
  
  // Get all elements with menu select class
  const elements = document.querySelectorAll("[data-filter-type='menuSelect']")
  const elementsArray = Array.from(elements)
  
  // Group together menu select elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);

      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach(element => {
        const widgetID = element.getAttribute('data-id')
        const attribute = tgblAlgoliaData[widgetID]['attribute']
        
        let AlgoliaMenuSelect = ($, search, element) => {
          search.addWidgets([
            menuSelect({
              container: element,
              attribute: attribute, 
              cssClasses: {
                root: 'tgbl-menu-select',
                noRefinementRoot: 'tgbl-menu-select__noRefinementRoot',
                select: 'tgbl-menu-select__select',
                option: 'tgbl-menu-select__option'
              },
            })
          ]);
          registerWidget(element);
        };
        AlgoliaMenuSelect($, search, element);
      });
    }
  }
}

export { initMenuSelectWidget }
